import { render, staticRenderFns } from "./TwoFactorAuthenticationModal.vue?vue&type=template&id=3b0cb86c&scoped=true"
import script from "./TwoFactorAuthenticationModal.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthenticationModal.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorAuthenticationModal.vue?vue&type=style&index=0&id=3b0cb86c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0cb86c",
  null
  
)

export default component.exports